module.exports = __webpack_public_path__ + "static/media/sup_wc_was.7002aed5.png";